import "./App.css";
import "./styles/Home.css";

// img
import logo from "./assets/logo1.png";
import logo2 from "./assets/logo2.png";

import logo3 from "./assets/logo3.png";
import arrowDown from "./assets/arrowDown.png";
import prod1 from "./assets/prod2.png";
import mobileMenu from "./assets/mobileMenu.png";

import loader from "./assets/load.gif";

import message from "./assets/telegram.png";
import call from "./assets/call.png";
import email from "./assets/email.png";
import location from "./assets/location.png";
import up_cheveron from "./assets/up-chevron.png";
//socials
import facebook from "./assets/socials/facebook.png";
import instagram from "./assets/socials/instagram.png";
import x from "./assets/socials/twitter.png";
import youtube from "./assets/socials/media.png";

import mobileBack from "./assets/mobileBack.png";
import cartIcon from "./assets/cart.png";

import React, { useEffect, useState, useRef, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HoverComponent from "./Components/MUI/HoverComponent";
import Products from "./Components/products";

import event1 from "./assets/event1.jpg";
import event2 from "./assets/event2.jpg";
import event3 from "./assets/event3.jpg";

import {
  useNavigate,
  HashRouter as Router,
  Route,
  Routes,
  Link,
} from "react-router-dom";
import ProductDetails from "./Components/ProductDetails";
import ImageSlider from "./Components/MUI/ImagesSilder";
import FlashPopUp from "./Components/MUI/FlashPopUp";
import CartContext, { CartProvider } from "./Context/CartContext";
import CartOverlay from "./Components/MUI/CartOverlay";
import CheckoutOverlay from "./Components/MUI/CheckoutOverlay";
import { AuthProvider, useAuth } from "./Context/AuthContext";
import AuthOverlay from "./Components/MUI/AuthOverlay";


import item1 from "./assets/section6/item1.png";
import item2 from "./assets/section6/item2.png";
import item3 from "./assets/section6/item3.png";
import item4 from "./assets/section6/item4.png";
import item5 from "./assets/section6/item5.png";
import item6 from "./assets/section6/item6.png";

import cardio from "./assets/cardio.png";
import Musculation from "./assets/Musculation.png";

import Tabs from "./Components/MUI/Tabs";
import FileInput from "./Components/MUI/FileInput";
import AlertOverlay from "./Components/MUI/AlertOverlay";

import {
  getActiveContent,
  getAllCategories,
  getProductById,
  saveWarrantyClaim,
  uploadFileToStorage,
} from "./Utils/Utils";

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ImageWithLoader from "./Components/MUI/LoaderImage";
import OverlayContainer from "./Components/MUI/OverlayContainer";

import deliveryLogo from "./assets/delivery.png";
import fastDeliveryIcon from "./assets/fast-delivery.png";
import professionalIcon from "./assets/pro.png";
import packagingIcon from "./assets/packaging.png";
import nationalCoverageIcon from "./assets/tracking.png";
import trackingIcon from "./assets/tracking.png";
import { set } from "firebase/database";

function openLinkInNewWindow(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}

// Header wrapper to access auth context
const HeaderWithAuth = ({ setCartOpen, setAuthOpen, setCheckoutOpen }) => {
  const { currentUser, signOut } = useAuth();

  return (
    <Header 
      setCartOpen={setCartOpen} 
      setAuthOpen={setAuthOpen}
      currentUser={currentUser}
      onLogout={signOut}
    />
  );
};

function App() {
  var [pageContent, setPageContent] = useState({});
  const [cartOpen, setCartOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  useEffect(() => {
    //window.scroll(0, 0);
    const unsubscribe = getActiveContent((data) => {
      console.log(data);
      setPageContent(data);
    });

    // Cleanup on unmount
    return () => unsubscribe();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <div className="App">
            <HeaderWithAuth setCartOpen={setCartOpen} setAuthOpen={setAuthOpen} setCheckoutOpen={setCheckoutOpen} />
            <FlashPopUp darkMode={false} />
            <CartOverlay stat={cartOpen} toggleOverlay={() => setCartOpen(false)} setCheckoutOpen={setCheckoutOpen} />
            <CheckoutOverlay stat={checkoutOpen} toggleOverlay={() => setCheckoutOpen(false)} />
            <AuthOverlay stat={authOpen} toggleOverlay={() => setAuthOpen(false)} />
            <Routes>
              {/* Main page with sections */}
              <Route
                path="/"
                element={
                  <>
                    <Home pageContent={pageContent} />

                    <CategoriesSection />

                    <Section5 pageContent={pageContent} />
                    <Section6 />

                    <Section2 pageContent={pageContent} />
                    <Section3 pageContent={pageContent} />

                    <CaritativeSection />

                    <Section7 />
                    <EventSection />
                    <Section4 />
                    <DeliverySection />
                    <AfterSalesServiceSection />
                    <Footer pageContent={pageContent} />
                  </>
                }
              />
              {/* Separate page with Header, Home, Products, and Footer */}
              <Route
                path="/products/:categoryId?/:subCategoryId?"
                element={
                  <>
                    <Home pageContent={pageContent} />
                    <Products />
                    <Footer pageContent={pageContent} />
                  </>
                }
              />
              <Route
                path="/product-details/:productId"
                element={
                  <>
                    {" "}
                    <ProductDetails pageContent={pageContent} />{" "}
                    <Footer pageContent={pageContent} />{" "}
                  </>
                }
              />
            </Routes>
          </div>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

const Home = ({ pageContent }) => {
  const [images, setImages] = useState([]);
  const scrollToSection = (sectionId) => {
    if (document.getElementById(sectionId)) {
      document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <motion.div id="home" className="section home px-80 box-sizing">
      <motion.div
        className="w-full relative h-full border-radius-5 bg-grey  box-sizing flex justify-space-between  px-80 "
        initial={{ opacity: 0, top: "100px" }}
        animate={{ opacity: 1, top: "0", transition: { delay: 2.2 } }}
      >
        <ImageSlider
          images={
            pageContent && pageContent["home-background"]
              ? pageContent["home-background"]
              : []
          }
          interval={4000}
        />
        <motion.div className="home-left  flex-column justify- relative">
          <div>
            <motion.div className="relative small-hr bg-orange border-radius-5 my-10"></motion.div>
            <motion.p className="sec-text bold relative">
              {pageContent && pageContent["home-heading"]
                ? pageContent["home-heading"]
                : null}
            </motion.p>
            <motion.p className=" my-20 relative">
              {pageContent && pageContent["home-description"]
                ? pageContent["home-description"]
                : null}
            </motion.p>

            <motion.div
              className="action-button bg-orange"
              onClick={() => {
                if (document.getElementById("section2")) {
                  scrollToSection("section2");
                } else {
                  setTimeout(() => {
                    scrollToSection("section2");
                  }, 500); // Delay of 500ms
                }
              }}
            >
              <p className="btn">Découvrez maintenant</p>
            </motion.div>
          </div>
        </motion.div>
      </motion.div>

      <motion.div className="section fixed preloader-container relative">
        <motion.img
          alt=""
          src={loader}
          className="logo-img"
          initial={{ scale: 1.2 }}
          animate={{ scale: 0, transition: { delay: 1.6 } }}
        />
      </motion.div>
    </motion.div>
  );
};

const EventSection = () => {
  return (
    <div
      id="event-section"
      className="section event-section w-full h-full flex justify-space-between box-sizing"
    >
      <ImageSlider images={[event1, event2]} />
      <div className="event-content  white flex-column align-items-center justify-center">
        <p className="sec-text my-20 bold">
          {" "}
          Active Fitness <span className="bg-blue">Évenement</span>
        </p>
        <p className="text bold w-1-2">
          {" "}
          nous aimons aller à la rencontre de notre communauté ! Nous
          participons régulièrement à des salons, foires et événements liés au
          sport, au bien-être et à la remise en forme.
        </p>

        <div className="event-grid">
          <p>Présenter nos dernières collections et produits</p>
          <p>Échanger directement avec nos clients et partenaires</p>
          <p>Promouvoir un mode de vie actif et inspirant</p>
        </div>
      </div>
    </div>
  );
};

const CaritativeSection = () => {
  return (
    <div
      id="section-caritative"
      className="section section-caritative w-full h-full flex justify-space-between px-80 box-sizing"
    >
      <div className="caritative-content">
        <img src={logo} alt="" className="" />
        <p className="sec-text bold">Engagement & Solidarité</p>
        <motion.div className="relative small-hr bg-orange border-radius-5 my-10"></motion.div>

        <p className="w-1-2 center-text my-20">
          Chez <span className="bold blue">Active Fitness</span>, nous plaçons
          la responsabilité sociale au cœur de notre démarche. Nous soutenons
          régulièrement des initiatives caritatives à travers des actions
          concrètes et événements solidaires. Un engagement durable, en accord
          avec nos valeurs.{" "}
        </p>
      </div>
    </div>
  );
};

const Section2 = ({ pageContent }) => {
  var [images, setImages] = useState([]);
  const scrollToSection = (sectionId) => {
    if (document.getElementById(sectionId)) {
      document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    console.log(pageContent["second-slider-images"]);
    setImages(pageContent["second-slider-images"]);
  }, [pageContent]);

  return (
    <div
      id="section2"
      className="section section2 w-full h-full flex justify-space-between px-80 box-sizing"
    >
      <div className="flex relative align-items-center justify-center section2-left  h-full  border-radius-5 bg-grey">
        {images && images.length > 0 ? <ImageSlider images={images} /> : null}
      </div>
      <div className="flex section2-right flex-column justify-center">
        <p className="sec-text bold ">Missions d'Active Fitness</p>
        <p className="small-text">
          Notre mission est de fournir des équipements de fitness de haute
          qualité qui permettent aux individus et aux communautés d'atteindre
          leurs objectifs de santé et de bien-être. Nous nous engageons à offrir
          des produits innovants et durables qui inspirent un mode de vie sain
          et soutiennent la réussite à long terme en matière de fitness.
        </p>
        <div className="my-20">
          <p className="bold">Mission de l'entreprise 1</p>
          <p className="small-text">
            Proposer des équipements de fitness premium à des prix abordables,
            conçus pour répondre aux besoins divers des clients.
          </p>
        </div>

        <div className="">
          <p className="bold">Mission de l'entreprise 2</p>
          <p className="small-text">
            Fournir des conseils personnalisés et des recommandations d'experts
            pour garantir que nos clients font les meilleurs choix pour leurs
            objectifs de fitness.
          </p>
        </div>

        <div className="my-20">
          <p className="bold">Mission de l'entreprise 3</p>
          <p className="small-text">
            Offrir un service après-vente exceptionnel, incluant la maintenance
            et les pièces détachées, pour prolonger la durée de vie de chaque
            produit.
          </p>
        </div>

        <div
          className="action-button bg-orange my-20"
          onClick={() => {
            if (document.getElementById("section-tabs")) {
              scrollToSection("section-tabs");
            } else {
              setTimeout(() => {
                scrollToSection("section-tabs");
              }, 500); // Delay of 500ms
            }
          }}
        >
          <p className="btn">Découvrez Nos Categories</p>
        </div>
      </div>
    </div>
  );
};

const Section3 = ({ pageContent }) => {
  var [images, setImages] = useState([]);

  useEffect(() => {
    console.log(pageContent["third-slider-images"]);
    setImages(pageContent["third-slider-images"]);
  }, [pageContent]);

  return (
    <div
      id="section3"
      className="section section3  w-full h-full flex-column justify-space-between px-80 box-sizing "
    >
      <div className="section3-content flex justify-space-between py-20 box-sizing">
        <div className="section3-left h-full w-1-2 flex-column justify-space-between">
          <p className="bold grey">
            Active Fitness<span className="">.</span>
          </p>
          <p className="sec-text bold">
            Active Fitness,
            <span className="bg-orange white border-radius-5">
              {" "}
              propose une large gamme{" "}
            </span>{" "}
            d'équipements et d'accessoires de fitness.
          </p>
          <p className="">
            Active Fitness Algérie propose une gamme variée d'équipements de
            fitness de haute qualité conçus pour répondre à divers besoins
            d'entraînement, du cardio à la musculation, offrant une expérience
            de fitness complète pour tous les utilisateurs.
          </p>
          <div className="fit-content-hr bg-black "></div>

          <div className=" flex justify-space-between w-full ">
            <div className="flex-column justify-space-between w-1-2   -20 py-20">
              <img alt="" src={cardio} className="logo-img" />
              <p className="bold my-10"> Équipements Cardio</p>
              <p className="small-text">
                {" "}
                Les tapis de course, vélos d'appartement et elliptiques offrent
                des solutions d'entraînement performantes et à faible impact,
                adaptées à tous les niveaux de fitness et favorisant la santé
                cardiovasculaire.
              </p>
            </div>

            <div className="flex-column justify-space-between w-1-2   -20 py-20 border-radius-5">
              <img alt="" src={Musculation} className="logo-img" />
              <p className="bold my-10"> Musculation & Accessoires</p>
              <p className="small-text">
                {" "}
                Les appareils de musculation et les rameurs soutiennent
                l'entraînement complet du corps, tandis que les accessoires
                sportifs comme les haltères, les bandes de résistance et les
                tapis de yoga améliorent chaque routine d'entraînement.
              </p>
            </div>
          </div>
        </div>

        <div className="section3-right flex-column border-radius-5 justify-center bg-grey h-full w-1-2">
          {images && images.length > 0 ? <ImageSlider images={images} /> : null}
        </div>
      </div>
    </div>
  );
};

const Section4 = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question:
        "Qu'est-ce qui fait d'Active Fitness Algérie une marque de fitness de confiance ?",
      answer:
        "Nous nous spécialisons dans les tapis de course de haute qualité et les solutions de fitness complètes, offrant un excellent rapport qualité-prix, un service après-vente exceptionnel et une approche centrée sur le client.",
    },
    {
      question:
        "Quels types d'équipements de fitness propose Active Fitness Algérie ?",
      answer:
        "Nous proposons une gamme complète d'équipements de fitness, y compris des tapis de course, des vélos d'appartement, des elliptiques, des rameurs, des appareils de musculation et divers accessoires sportifs pour répondre à différents besoins de fitness.",
    },
    {
      question:
        "Active Fitness Algérie propose-t-elle un service après-vente ?",
      answer:
        "Oui, nous assurons la satisfaction à long terme de nos clients en fournissant des services de maintenance, des pièces détachées et des conseils d'experts pour prolonger la durée de vie de vos équipements de fitness.",
    },
  ];

  return (
    <div
      id="section4"
      className="section4 section flex align-items-center justify-center w-full h-full px-80 box-sizing"
    >
      <div className="section4-content bg-grey w-full h-full flex-column align-items-center justify-center border-radius-5 py-20 box-sizing">
        <p className="sec-text bold">Questions fréquemment posées</p>
        <p className="small-text w-1-2 center-text my-20">
          Vous avez des questions sur Active Fitness Algérie ? Voici
          quelques-unes des questions les plus fréquentes sur nos produits,
          services et engagement envers la satisfaction client.
        </p>
        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            className="faq-item  pointer bg-white flex-column justify-space-between align-items-center w-full border-radius-5 my-10 box-sizing py-20"
            style={{ padding: "20px" }}
            onClick={() => toggleOpen(index)}
            initial={{ height: "auto" }}
            animate={{ height: openIndex === index ? "120px" : "60px" }}
            transition={{}}
          >
            <div className="flex justify-space-between w-full">
              <p className="faq-question bold grey small-text">
                {faq.question}
              </p>
              <motion.img
                alt=""
                src={arrowDown}
                className="logo-"
                x
                initial={{ rotate: "0" }}
                animate={{ rotate: openIndex === index ? "180deg" : "0" }}
              />
            </div>
            {openIndex === index && (
              <motion.p
                className="faq-answer flex align-items-start w-full small-text"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                {faq.answer}
              </motion.p>
            )}
          </motion.div>
        ))}
        <div className="action-button bg-orange my-20">
          <p className="btn">Demandez à notre équipe</p>
        </div>
      </div>
    </div>
  );
};

const Section5 = ({ pageContent }) => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const ids = pageContent["relevent-products"].slice(0, 4); // Get first 4 IDs
        console.log(ids);
        // If you have a function to fetch one product by ID:
        const productPromises = ids.map((id) => getProductById(id));
        const fetchedProducts = await Promise.all(productPromises);

        console.log("..... relevent products ");
        setProducts(fetchedProducts);

        console.log(products[0].imagesUrls[0]);
        console.log("Fetched relevant products:", fetchedProducts);
      } catch (error) {
        console.error("Error fetching relevant products:", error);
      }
    };

    fetchProducts();
  }, [pageContent]);

  return (
    <div
      id="section5"
      className="section5 section flex-column  align-items-center justify-space-between w-full h-full px-80 box-sizing"
    >
      <p className="sec-text bold">Produits pertinents de l'entreprise</p>

      <div className="section5-content flex justify-space-between align-items-center w-full box-sizing">
        <div className="section5-left relative h-full w-1-2 border-radius-5   flex-column justify-space-between align-items ">
          <div className="section5-product  flex relative justify-space-between align-items bg-grey py-20 px-20 box-sizing">
            <div className="product-img h-full  bg-white border-radius-5 px-10 box-sizing py-10">
              {products[0] && products[0].imagesUrls && (
                <ImageWithLoader
                  src={products[0].imagesUrls[0]}
                  alt="product image"
                />
              )}
            </div>
            <div className="product-texts flex-column">
              <p className="bold small-text">
                {products[0] && products[0].productName
                  ? products[0].productName
                  : null}
                {" : "}Produits pertinents de l'entreprise
              </p>

              <p className="small-text specifications">
                {products[0] && products[0].specifications}
              </p>
            </div>
            <div className="product-price flex align-items-center h-full">
              <p
                className="small-text bold bg-orange pointer white px-20 py-10 border-radius-20"
                onClick={() => {
                  if (products && products[0] && products[0].id) {
                    navigate(`/product-details/${products[0].id}`, {
                      state: { product: products[0] },
                    });
                  }
                }}
              >
                {products[0] && products[0].price ? products[0].price : null} DA
              </p>
            </div>
          </div>

          <div className="section5-product flex relative justify-space-between align-items bg-grey py-20 px-20 box-sizing">
            <div className="product-img h-full bg-white border-radius-5 px-10 box-sizing py-10">
              {products[1] && products[1].imagesUrls && (
                <ImageWithLoader
                  src={products[1].imagesUrls[0]}
                  alt="product image"
                />
              )}
            </div>
            <div className="product-texts flex-column">
              <p className="bold small-text">
                {products[1] && products[1].productName
                  ? products[1].productName
                  : null}
                {" : "}Produits pertinents de l'entreprise
              </p>
              <p className="small-text specifications">
                {products[1] && products[1].specifications}
              </p>
            </div>
            <div className="product-price flex align-items-center h-full">
              <p
                className="small-text bold bg-orange white pointer px-20 py-10 border-radius-20"
                onClick={() => {
                  if (products && products[1] && products[1].id) {
                    navigate(`/product-details/${products[1].id}`, {
                      state: { product: products[1] },
                    });
                  }
                }}
              >
                {products[1] && products[1].price ? products[1].price : null} DA
              </p>
            </div>
          </div>

          <div className="section5-product flex relative justify-space-between align-items bg-grey py-20 px-20 box-sizing">
            <div className="product-img h-full bg-white border-radius-5 px-10 box-sizing py-10">
              {products[2] && products[2].imagesUrls && (
                <ImageWithLoader
                  src={products[2].imagesUrls[0]}
                  alt="product image"
                />
              )}
            </div>
            <div className="product-texts flex-column">
              <p className="bold small-text">
                {products[2] && products[2].productName
                  ? products[2].productName
                  : null}
                {" : "}Produits pertinents de l'entreprise
              </p>
              <p className="small-text specifications">
                {products[2] && products[2].specifications}
              </p>
            </div>
            <div className="product-price flex align-items-center h-full">
              <p
                className="small-text bold bg-orange white pointer px-20 py-10 border-radius-20"
                onClick={() => {
                  if (products && products[2] && products[2].id) {
                    var prod = products[2];
                    console.log(prod);
                    navigate(`/product-details/${products[2].id}`, {
                      state: { product: products[2] },
                    });
                  }
                }}
              >
                {products[2] && products[2].price ? products[2].price : null} DA
              </p>
            </div>
          </div>
        </div>
        <div className="section5-right  bg-grey border-radius-5 flex-column  justify-center align-items-center">
          <div className="section5-right-img relative  flex justify-center">
            {products[3] && products[3].imagesUrls && (
              <ImageWithLoader
                src={products[3].imagesUrls[0]}
                alt="product image"
              />
            )}
          </div>
          <p className="bold grey small-text ">
            {products[3] && products[3].brandName}
          </p>
          <h2 className="bold">{products[3] && products[3].productName}</h2>

          <div className="flex  my-20">
            <div
              className="action-button bg-orange mx-10"
              onClick={() => {
                if (products && products[3] && products[3].id) {
                  var prod = products[3];
                  console.log(prod);
                  navigate(`/product-details/${products[3].id}`, {
                    state: { product: products[3] },
                  });
                }
              }}
            >
              <p className="btn ">Details De Produit</p>
            </div>
            <div
              className="action-button bg-orange mx-10"
              onClick={() => {
                navigate(`/products`);
              }}
            >
              <p className="btn">Voir nos produits</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Section6 = () => {
  return (
    <div
      id="section6"
      className="section section6 w-full h-full flex-column justify-center px-80 box-sizing"
    >
      <div className="section6-content flex-column justify-center align-items-center">
        <p className="sec-text bold">Notre Engagement envers Vous</p>
        <p className="small-text w-1-2 center-text my-20">
          Chez Active Fitness, nous nous engageons à vous offrir la meilleure
          expérience de fitness. Notre dévouement à la qualité, au service et à
          l'innovation garantit que vous pouvez nous faire confiance pour
          soutenir votre parcours de fitness à chaque étape.
        </p>

        <div className="grid-container w-full grid grid-cols-3 gap-20 my-20">
          <div className="grid-item bg- border-radius-5 p-20 flex-column align-items-center">
            <img alt="" src={item1} className="logo-img" />
            <p className="bold my-10">Assurance Qualité</p>
            <p className="small-text">
              Nous veillons à ce que chaque produit réponde aux normes de
              qualité et de durabilité les plus élevées. Des tapis de course aux
              accessoires, notre équipement est conçu pour durer et performer.
            </p>
          </div>

          <div className="grid-item border-radius-5 p-20 flex-column align-items-center">
            <img alt="" src={item2} className="logo-img" />
            <p className="bold my-10">Support Client</p>
            <p className="small-text">
              Notre équipe est toujours là pour vous aider. Du choix des
              produits au service après-vente, nous fournissons des conseils
              experts et un support personnalisé pour garantir votre
              satisfaction.
            </p>
          </div>

          <div className="grid-item bg- border-radius-5 p-20 flex-column align-items-center">
            <img alt="" src={item3} className="logo-img" />
            <p className="bold my-10">Innovation</p>
            <p className="small-text">
              Nous innovons continuellement pour vous apporter les dernières
              technologies en matière de fitness. Nos produits sont conçus pour
              améliorer vos entraînements et vous garder motivé.
            </p>
          </div>

          <div className="grid-item bg- border-radius-5 p-20 flex-column align-items-center">
            <img alt="" src={item4} className="logo-img" />
            <p className="bold my-10">Durabilité</p>
            <p className="small-text">
              Nous nous engageons à réduire notre impact environnemental. Nos
              produits et processus sont conçus avec la durabilité à l'esprit,
              assurant une planète plus saine pour les générations futures.
            </p>
          </div>

          <div className="grid-item bg- border-radius-5 p-20 flex-column align-items-center">
            <img alt="" src={item5} className="logo-img" />
            <p className="bold my-10">Accessibilité</p>
            <p className="small-text">
              Le fitness devrait être accessible à tous. Nous proposons une
              large gamme de produits à différents prix, garantissant que chacun
              peut trouver quelque chose qui correspond à son budget.
            </p>
          </div>

          <div className="grid-item bg- border-radius-5 p-20 flex-column align-items-center">
            <img alt="" src={item6} className="logo-img" />
            <p className="bold my-10">Engagement Communautaire</p>
            <p className="small-text">
              Nous croyons en la construction d'une communauté de fitness forte.
              À travers des événements, des défis et les réseaux sociaux, nous
              nous connectons avec nos clients et soutenons leurs parcours de
              fitness.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const Section7 = () => {
  return (
    <div
      id="section7"
      className="section section7 w-full h-full flex-column justify-center px-80 box-sizing"
    >
      {/* Comment Nous Servons Notre Public Cible */}
      <div className="section7-part1 flex justify-space-between align-items-center my-40">
        <div className="section7-part1-left w-1-2 flex-column justify-center">
          <p className="sec-text bold">
            Comment Nous Servons Notre Public Cible
          </p>
          <p className="small-text my-20">
            Chez Active Fitness, nous répondons aux besoins d'un public
            diversifié en proposant une large gamme de produits et services
            adaptés à leurs besoins. Des débutants aux passionnés de fitness,
            nous veillons à ce que chacun trouve la solution idéale pour son
            parcours de fitness.
          </p>
        </div>

        <div className="section7-part1-right w-1-2 flex justify-end">
          <img alt="" src={logo} />
        </div>
      </div>

      <div className="section7-part2 flex-column justify-content-center  align-items-center ">
        <p className="sec-text bold">
          Principaux points de vue des Marques de Matériel de Fitness à Succès
        </p>
        <p className="small-text w-1-2 center-text my-20">
          Nous nous inspirons des marques mondiales leaders pour fournir les
          meilleures solutions de fitness. Voici quelques insights de marques
          réussies dans l'industrie.
        </p>

        <div className="brand-grid w-full grid grid-cols-3 gap-20 my-20">
          {/* Decathlon */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img src={logo2} alt="Logo Decathlon" className="logo" />

            <p className="small-text">
              Se concentre sur l'accessibilité et l'abordabilité, offrant une
              large gamme de produits sportifs et de fitness pour tous les
              niveaux.
            </p>
          </div>

          {/* ProForm */}
          <div className="brand-item  border-radius-5 p-20 flex-column align-items-center">
            <img src={logo3} alt="Logo ProForm" className="logo" />

            <p className="small-text">
              Connu pour son équipement innovant et performant avec des
              fonctionnalités d'entraînement interactif comme la compatibilité
              iFit.
            </p>
          </div>

          {/* NordicTrack */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img src={logo} alt="Logo NordicTrack" className="logo" />

            <p className="small-text">
              Propose des équipements de fitness premium et durables avec une
              technologie avancée pour une expérience de salle de gym à domicile
              professionnelle.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeliverySection = () => {
  return (
    <div
      id="section7"
      className="section DeliverySection  section7 w-full h-full flex-column justify-center px-80 box-sizing"
    >
      {/* Notre Service de Livraison */}

      <div className="section7-part flex justify-space-between align-items-center my-40 ">
        <div className="section7-part1-left w-1-2 flex-column justify-center">
          <p className="sec-text bold">
            Un service de livraison fiable, Rapide, sécurisé et national
          </p>
          <p className="small-text my-20">
            Peu importe votre localisation en Algérie, notre équipe logistique
            veille à ce que votre commande vous parvienne dans les délais et en
            parfait état.
          </p>
        </div>

        <div className="section7-part1-right w-1-2 flex justify-center  align-items-center  bg-white">
          <img alt="Service de livraison" src={logo} className="" />
        </div>
      </div>

      <div className="section7-part2 bg-blue white flex-column align-items-center">
        <p className="sec-text bold ">Ce que nous garantissons</p>
        <p className="small-text w-1-2 center-text my-20">
          Notre engagement pour une expérience de livraison sans souci à travers
          toute l'Algérie.
        </p>

        <div className="grid  w-full grid grid-cols-5 gap-20 my-20">
          {/* Rapidité */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img
              src={fastDeliveryIcon}
              alt="Icône rapidité"
              className="logo-img bg-white"
            />

            <p className="small-text">
              Traitement rapide des commandes sous 24 à 48 heures
            </p>
          </div>

          {/* Couverture */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img
              src={nationalCoverageIcon}
              alt="Icône couverture nationale"
              className="logo-img bg-white"
            />

            <p className="small-text ">
              Livraison dans toutes les wilayas du pays
            </p>
          </div>

          {/* Professionnalisme */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img
              src={professionalIcon}
              alt="Icône professionnalisme"
              className="logo-img bg-white"
            />

            <p className="small-text">
              Personnel de livraison formé, courtois et professionnel
            </p>
          </div>

          {/* Emballage */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img
              src={packagingIcon}
              alt="Icône emballage"
              className="logo-img bg-white"
            />

            <p className="small-text">
              Emballage soigné pour éviter tout dommage
            </p>
          </div>

          {/* Suivi */}
          <div className="brand-item border-radius-5 p-20 flex-column align-items-center">
            <img
              src={trackingIcon}
              alt="Icône suivi"
              className="logo-img bg-white"
            />

            <p className="small-text">Suivi en temps réel possible</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const CategoriesSection = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCategories = async () => {
      console.log("fetching categories.....");
      try {
        console.log("fetching categories.....");
        const data = await getAllCategories();
        setCategories(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const tabsData = categories.map((cat) => ({
    buttonContent: <p>{cat.categoryName}</p>,
    content: (
      <div className="tabs-content">
        {cat.subcategories
          .sort((a, b) => {
            // If order is not defined for some items, you might want to handle that case
            const orderA = a.order !== undefined ? a.order : Infinity;
            const orderB = b.order !== undefined ? b.order : Infinity;
            return orderA - orderB;
          })
          .map((sub, index) => (
            <div
              key={index}
              className="tab-grid-item flex align-items-center"
              onClick={() => {
                navigate(`/products/${cat.id}/${sub.id}`);
              }}
            >
              <img
                alt={sub.name}
                src={
                  sub.subcategoryImagesUrls
                    ? sub.subcategoryImagesUrls[0]
                    : prod1
                }
              />
              <p className="small-text mx-20">{sub.subcategoryName} </p>
            </div>
          ))}
      </div>
    ),
  }));

  return (
    <div
      id="section-tabs"
      className="section Categories-section w-full h-full flex-column justify-center px-80 box-sizing"
    >
      <p className="sec-text bold">
        Découvrez les catégories de produits Active Fitness
      </p>
      <p className="small-text w-1-2 center- my-20">
        Explorez notre gamme diversifiée d’équipements de fitness, d’accessoires
        sportifs et vêtements. Chaque catégorie offre une sélection
        soigneusement organisée pour s’adapter votre parcours de remise en
        forme. Cliquez sur les onglets pour produits pour vos besoins.
      </p>
      <Tabs tabs={tabsData} />
    </div>
  );
};
const AfterSalesServiceSection = () => {
  const [uploadingFiles, setUploadingFiles] = useState(false);
  const [alertState, setAlertState] = useState({
    open: false,
    title: "",
    message: "",
  });

  const [formData, setFormData] = useState({
    clientName: "",
    invoiceNumber: "",
    purchaseDate: "",
    productType: "",
    productName: "",
    phoneNumber: "",
    contactEmail: "",
    underWarranty: "",
    warrantyCertificate: null,
    invoiceFile: null,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploadingFiles(true);

    try {
      let warrantyUrl = null;
      let invoiceUrl = null;

      // Upload warrantyCertificate if present
      if (formData.warrantyCertificate) {
        warrantyUrl = await uploadFileToStorage(
          formData.warrantyCertificate,
          "warranty-certificates"
        );
      }

      // Upload invoiceFile if present
      if (formData.invoiceFile) {
        invoiceUrl = await uploadFileToStorage(
          formData.invoiceFile,
          "invoices"
        );

        setUploadingFiles(false);
      }

      // Save to Firebase DB
      await saveWarrantyClaim({
        ...formData,
        warrantyCertificate: warrantyUrl,
        invoiceFile: invoiceUrl,
      });

      setAlertState({
        open: true,
        title: "Succès",
        message: "Votre demande a été enregistrée avec succès.",
      });

      // Optionally clear form
      setFormData({
        clientName: "",
        invoiceNumber: "",
        purchaseDate: "",
        productType: "",
        productName: "",
        phoneNumber: "",
        contactEmail: "",
        underWarranty: "",
        warrantyCertificate: null,
        invoiceFile: null,
        message: "",
      });
    } catch (err) {
      console.log("Submission failed:", err);
      setAlertState({
        open: true,
        title: "Erreur",
        message: "Échec de l\x27envoi. Veuillez réessayer.",
      });
    }
  };

  return (
    <div
      id="after-sales-service"
      className="section after-sales-service w-full h-full flex-column justify-center px-80 box-sizing"
    >
      <p className="sec-text bold">Service Après-Vente</p>
      <p className="small-text w-1-2  my-20">
        Notre service après-vente est là pour vous accompagner en cas de besoin.
        Remplissez le formulaire ci-dessous avec les informations nécessaires
        pour que notre équipe puisse traiter votre demande rapidement et
        efficacement.
      </p>
      <form className="after-sales-form" onSubmit={handleSubmit}>
        <div className="input-container">
          <label>Nom et Prénom :</label>
          <input
            type="text"
            name="clientName"
            placeholder="Saisissez Votre nom et prénom"
            value={formData.clientName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-container">
          <label>Numéro de facture :</label>
          <input
            type="text"
            name="invoiceNumber"
            placeholder="Saisissez le numéro de facture"
            value={formData.invoiceNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-container">
          <label>Date d’achat :</label>
          <input
            type="date"
            name="purchaseDate"
            value={formData.purchaseDate}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-container">
          <label>Type de produit :</label>
          <input
            type="text"
            name="productType"
            placeholder="Saisissez le type de produit"
            value={formData.productType}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-container">
          <label>Nom du produit :</label>
          <input
            type="text"
            name="productName"
            placeholder="Saisissez le nom du produit"
            value={formData.productName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-container">
          <label>Numéro de téléphone :</label>
          <input
            type="tel"
            name="phoneNumber"
            placeholder="Saisissez votre numéro de téléphone"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-container">
          <label>E-mail de contact :</label>
          <input
            type="email"
            name="contactEmail"
            placeholder="Saisissez votre e-mail"
            value={formData.contactEmail}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-container">
          <label>Le produit est-il toujours sous garantie ? (Oui/Non)</label>
          <input
            type="text"
            name="underWarranty"
            placeholder="Oui / Non"
            value={formData.underWarranty}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-container">
          <label>
            Télécharger le certificat de garantie / Photo De Produit
          </label>
          <FileInput
            backgroundColor="#28a745"
            name="warrantyCertificate"
            value={formData.warrantyCertificate}
            onChange={handleChange}
          />
        </div>
        <div className="input-container">
          <label>Télécharger la facture</label>
          <FileInput
            backgroundColor="#28a745"
            name="invoiceFile"
            onChange={handleChange}
            value={formData.invoiceFile}
          />
        </div>

        <div className="input-container">
          <textarea
            placeholder="Veuillez Saisir Votre Message..."
            className="input my-20 py-10"
            onChange={handleChange}
            name="message"
            value={formData.message}
            draggable={false}
          />
        </div>

        <button
          type="submit"
          className="action-button sav-btn bg-orange my-20  "
        >
          <motion.p
            className="btn absolute"
            initial={{ opacity: 0 }}
            animate={uploadingFiles ? { opacity: 1 } : { opacity: 0 }}
          >
            Importation...
          </motion.p>
          <motion.p
            className="btn"
            initial={{ opacity: 0 }}
            animate={!uploadingFiles ? { opacity: 1 } : { opacity: 0 }}
          >
            Envoyer
          </motion.p>
        </button>
      </form>
      <AlertOverlay
        stat={alertState.open}
        title={alertState.title}
        message={alertState.message}
        onClose={() => setAlertState((prev) => ({ ...prev, open: false }))}
        autoCloseMs={1500}
      />
    </div>
  );
};

const Footer = ({ pageContent }) => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      console.log("fetching categories.....");
      try {
        console.log("fetching categories.....");
        const data = await getAllCategories();
        setCategories(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const [overlay, toggleOverlay] = useState(false);

  const [overlay2, toggleOverlay2] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.div
      id="footer"
      className="section footer w-full h-full flex-column justify-center px-80 box-sizing politique-overlay"
    >
      <OverlayContainer
        contentHeight={"80vh"}
        contentWidth={"50vw"}
        className={"poltique-overlay"}
        stat={overlay}
        toggleOverlay={() => {
          toggleOverlay(false);
        }}
        children={
          <div>
            <img src={logo} className="logo-img" alt="" />
            <h3 className="my-20 blue">
              ACTIVE FITNESS | Politique de Confidentialité et de Protection des
              Données
            </h3>
            <article className="">
              <section>
                <h3>Article 1 : Objet de la politique</h3>
                <p>
                  Cette politique explique comment ACTIVE FITNESS collecte,
                  utilise, conserve et protège les données personnelles des
                  utilisateurs lors de l’utilisation de notre site, nos
                  applications ou notre service client.
                </p>
              </section>

              <section>
                <h3>Article 2 : Données collectées</h3>
                <p>Nous pouvons collecter les données suivantes :</p>
                <ul>
                  <li>Nom complet</li>
                  <li>Numéro de téléphone</li>
                  <li>Adresse e-mail</li>
                  <li>Adresse de livraison</li>
                  <li>Historique de commandes</li>
                  <li>Adresse IP et données de navigation</li>
                  <li>Messages échangés avec le service client</li>
                </ul>
              </section>

              <section>
                <h3>Article 3 : Utilisation des données</h3>
                <p>Les données sont utilisées uniquement pour :</p>
                <ul>
                  <li>Gérer les commandes et les livraisons</li>
                  <li>Gérer les comptes clients</li>
                  <li>Répondre aux demandes</li>
                  <li>Améliorer l’expérience utilisateur</li>
                  <li>Respecter les obligations légales et fiscales</li>
                </ul>
                <p>Nous ne vendons ni ne louons vos données à des tiers.</p>
              </section>

              <section>
                <h3>Article 4 : Conservation des données</h3>
                <ul>
                  <li>
                    Les données sont stockées en toute sécurité conformément à
                    la loi algérienne.
                  </li>
                  <li>
                    Elles sont conservées uniquement le temps nécessaire aux
                    finalités commerciales ou légales.
                  </li>
                </ul>
              </section>

              <section>
                <h3>Article 5 : Partage des données</h3>
                <p>Nous partageons les données uniquement avec :</p>
                <ul>
                  <li>Les transporteurs partenaires</li>
                  <li>Les autorités si requis légalement</li>
                  <li>Les prestataires de paiement en ligne</li>
                </ul>
                <p>
                  Tous les tiers sont tenus au respect de la confidentialité.
                </p>
              </section>

              <section>
                <h3>Article 6 : Cookies et traçage</h3>
                <p>Nous utilisons des cookies pour :</p>
                <ul>
                  <li>Analyser le trafic</li>
                  <li>Enregistrer les préférences utilisateurs</li>
                  <li>Assurer la sécurité de la navigation et du panier</li>
                </ul>
                <p>
                  Vous pouvez désactiver les cookies via les paramètres de votre
                  navigateur.
                </p>
              </section>

              <section>
                <h3>Article 7 : Droits des utilisateurs</h3>
                <p>Vous avez le droit de :</p>
                <ul>
                  <li>Accéder à vos données</li>
                  <li>Corriger des données erronées</li>
                  <li>Demander la suppression (sauf obligation légale)</li>
                  <li>Vous opposer à certains traitements</li>
                </ul>
                <p>
                  Les demandes doivent être envoyées via notre formulaire de
                  contact ou email.
                </p>
              </section>

              <section>
                <h3>Article 8 : Confidentialité du compte</h3>
                <p>
                  Vous êtes responsable de la confidentialité de vos
                  identifiants. ACTIVE FITNESS décline toute responsabilité en
                  cas d’usage frauduleux dû à une négligence.
                </p>
              </section>

              <section>
                <h3>Article 9 : Mesures de sécurité</h3>
                <p>
                  Nous appliquons des mesures techniques et organisationnelles
                  pour sécuriser vos données, notamment :
                </p>
                <ul>
                  <li>Le chiffrement</li>
                  <li>Des serveurs sécurisés</li>
                  <li>Un accès restreint aux données</li>
                </ul>
              </section>

              <section>
                <h3>Article 10 : Mise à jour de la politique</h3>
                <p>
                  Cette politique peut être mise à jour. Toute modification sera
                  publiée sur notre site. La poursuite de l’utilisation du
                  service vaut acceptation.
                </p>
              </section>
            </article>
          </div>
        }
      />
      <OverlayContainer
        contentHeight={"80vh"}
        contentWidth={"50vw"}
        className={"condition-overlay"}
        stat={overlay2}
        toggleOverlay={() => {
          toggleOverlay2(false);
        }}
        children={
          <div>
            <img src={logo} className="logo-img" alt="" />
            <h3 className="my-20 blue">
              ACTIVE FITNESS | Conditions Générales de Vente et d’Utilisation
            </h3>
            <article>
              <div class="article">
                <h3>Article 1 : Informations sur l’entreprise</h3>
                <p>
                  Cette activité de vente en ligne est exercée par ACTIVE
                  FITNESS, une entreprise de droit algérien, enregistrée
                  conformément à la réglementation sur le commerce électronique,
                  et possédant :
                </p>
                <ul>
                  <li>Registre de commerce : n° [...]</li>
                  <li>Numéro d’identification fiscale (NIF) : [...]</li>
                  <li>Adresse : [...]</li>
                  <li>Email officiel : [...]</li>
                  <li>Numéro de téléphone : [...]</li>
                </ul>
                <p>
                  Toute commande sur ce site constitue une acceptation totale
                  des conditions ci-dessous.
                </p>
              </div>

              <div class="article">
                <h3>Article 2 : Champ d’application</h3>
                <p>
                  Les présentes conditions s’appliquent à toutes les ventes et
                  prestations effectuées via le site d’ACTIVE FITNESS, que ce
                  soit en ligne, par téléphone ou au siège, et engagent
                  légalement toutes les parties.
                </p>
              </div>

              <div class="article">
                <h3>Article 3 : Acceptation des conditions</h3>
                <p>
                  Tout client reconnaît avoir lu, compris et accepté sans
                  réserve les présentes conditions. Cette acceptation est
                  confirmée en cliquant sur le bouton « Confirmer la commande »
                  ou son équivalent.
                </p>
              </div>

              <div class="article">
                <h3>Article 4 : Produits</h3>
                <ul>
                  <li>
                    Les images du site sont à titre illustratif uniquement.
                  </li>
                  <li>
                    Les couleurs ou dimensions peuvent légèrement différer sans
                    constituer un défaut.
                  </li>
                  <li>
                    Le client est responsable de vérifier l’adéquation du
                    produit à ses besoins.
                  </li>
                  <li>
                    L’usage abusif est interdit (surcharge, usage professionnel
                    non autorisé...).
                  </li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 5 : Prix et Paiement</h3>
                <ul>
                  <li>
                    Tous les prix sont en dinars algériens et incluent les
                    taxes.
                  </li>
                  <li>ACTIVE FITNESS peut modifier les prix sans préavis.</li>
                  <li>
                    La commande n’est définitive qu’après confirmation et
                    l’expédition n’a lieu qu’après accord sur le mode de
                    paiement.
                  </li>
                  <li>
                    En cas de paiement à la livraison, le client doit honorer
                    son engagement, sous peine d’interdiction future.
                  </li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 6 : Livraison</h3>
                <ul>
                  <li>
                    Les produits sont livrés à l’adresse fournie sur le
                    territoire algérien.
                  </li>
                  <li>
                    Aucun dédommagement ne sera accordé en cas de retard dû à
                    des circonstances indépendantes.
                  </li>
                  <li>
                    Un refus injustifié de réception donne droit à l’entreprise
                    d’annuler toute relation future et de réclamer les frais
                    d’expédition.
                  </li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 7 : Droit de Rétractation</h3>
                <p>Selon la loi 18-05 :</p>
                <ul>
                  <li>
                    Le client peut se rétracter sous 7 jours à condition que :
                  </li>
                  <ul>
                    <li>Le produit soit neuf, non ouvert, en état d’origine</li>
                    <li>Reçu dans son emballage avec tous ses accessoires</li>
                  </ul>
                  <li>❌ Aucune rétractation possible pour :</li>
                  <ul>
                    <li>Produits essayés ou montés</li>
                    <li>
                      Vêtements à usage personnel (sous-vêtements, t-shirts de
                      sport)
                    </li>
                    <li>Commandes spéciales ou sur mesure</li>
                  </ul>
                </ul>
              </div>

              <div class="article">
                <h3>Article 8 : Garantie et Responsabilité</h3>
                <ul>
                  <li>
                    Tous les produits sont garantis contre les défauts de
                    fabrication pour 3 ou 6 mois.
                  </li>
                  <li>Ne sont pas couverts :</li>
                  <ul>
                    <li>
                      Dommages liés à une mauvaise utilisation ou à la
                      négligence
                    </li>
                    <li>Cassures dues à un mauvais montage ou à un accident</li>
                    <li>
                      Utilisation dans un environnement inadapté (humidité,
                      chaleur, surcharge...)
                    </li>
                  </ul>
                  <li>
                    🛑 L’entreprise décline toute responsabilité en cas de
                    dommage corporel ou matériel lié à un usage abusif ou
                    incorrect.
                  </li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 9 : Limitation de Responsabilité</h3>
                <ul>
                  <li>
                    ACTIVE FITNESS n’est pas responsable des pertes indirectes
                    (perte de temps, d’activité, financières…).
                  </li>
                  <li>
                    La responsabilité est limitée à la valeur du produit vendu.
                  </li>
                  <li>
                    L’entreprise n’est pas responsable des pannes du site dues à
                    l’hébergeur.
                  </li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 10 : Force Majeure</h3>
                <ul>
                  <li>Catastrophes naturelles</li>
                  <li>Crises sanitaires (épidémies, pandémies…)</li>
                  <li>Grèves ou décisions administratives</li>
                  <li>Coupures d’Internet ou de services logistiques</li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 11 : Comptes en ligne</h3>
                <p>
                  Le client doit garder confidentielles ses données de compte.
                  L’entreprise n’est pas responsable des usages frauduleux dus à
                  une négligence du client.
                </p>
              </div>

              <div class="article">
                <h3>Article 12 : Propriété Intellectuelle</h3>
                <p>
                  Tout le contenu du site (images, textes, vidéos, design…) est
                  propriété d’ACTIVE FITNESS. Toute reproduction ou usage
                  commercial est interdit sans autorisation écrite.
                </p>
              </div>

              <div class="article">
                <h3>Article 13 : Lutte contre la diffamation en ligne</h3>
                <p>
                  Toute tentative de nuire à la réputation d’ACTIVE FITNESS via
                  les réseaux sociaux ou des avis mensongers constitue une
                  infraction et sera poursuivie selon la loi algérienne sur la
                  cybercriminalité.
                </p>
              </div>

              <div class="article">
                <h3>Article 14 : Règlement des litiges</h3>
                <ul>
                  <li>Le présent contrat est soumis au droit algérien.</li>
                  <li>
                    En cas de litige, le tribunal du siège d’ACTIVE FITNESS est
                    compétent.
                  </li>
                  <li>
                    Une tentative amiable doit précéder toute action judiciaire,
                    via courrier dans un délai de 15 jours.
                  </li>
                </ul>
              </div>

              <div class="article">
                <h3>Article 15 : Version Officielle</h3>
                <p>
                  La version arabe est la seule ayant une valeur juridique. Les
                  versions française et anglaise sont fournies à titre
                  d’information.
                </p>
              </div>

              <div class="article">
                <h3>Article 16 : Acceptation Finale</h3>
                <p>
                  En confirmant la commande, le client accepte pleinement et
                  sans réserve les présentes conditions, qui constituent un
                  contrat électronique engageant.
                </p>
              </div>
            </article>
          </div>
        }
      />

      <div className="footer-top border-radius-5 bg-grey p-20 mb-4 flex align-items-center justify-space-between">
        <div className="footer-top-left w-25">
          <p className="bold ">Abonnez-vous à notre newsletter</p>
        </div>
        <div className="footer-top-right w-1-2 flex align-items-center justify-end ">
          <div className="flex flex-col">
            <p>
              Rejoignez notre newsletter pour recevoir les dernières nouvelles,
              offres et mises à jour
            </p>
            <div className="flex align-items-baseline  justify-flex-start">
              <input
                className="mt-4 w-90 border-radius-20 py-20 box-sizing"
                type="text"
                placeholder="entrez votre email"
              />
              <div className="action-button  send-message-btn flex justify-center">
                <p className="btn">
                  <img
                    src={message}
                    alt="messager-icon"
                    height="20"
                    className="inverted-image50"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom border-radius-5 bg-grey p-20 flex ">
        <div className="w-25 ">
          <h3>Nos Categories</h3>
          <ul>
            {categories.map((cat) => {
              return (
                <li
                  onClick={() => {
                    navigate(`/products/${cat.id}`);
                  }}
                >
                  {cat.categoryName}
                </li>
              );
            })}
            <li></li>
            <li></li>
          </ul>
        </div>
        <div className="w-25">
          <h3>Liens utiles</h3>
          <ul>
            <li
              onClick={() => {
                scrollToSection("home");
              }}
            >
              Accueil
            </li>
            <li
              onClick={() => {
                scrollToSection("section6");
              }}
            >
              Entreprise
            </li>
            <li
              onClick={() => {
                scrollToSection("section4");
              }}
            >
              Faq
            </li>
            <li>
              <Link to={"/products/"} className="link">
                Nos Produits
              </Link>
            </li>
          </ul>
        </div>
        <div className="w-25">
          <h3>Support</h3>
          <ul>
            <li
              onClick={() => {
                scrollToSection("after-sales-service");
              }}
            >
              Service Après Vente
            </li>
            <li
              onClick={() => {
                toggleOverlay(true);
              }}
            >
              Politique de confidentialité
            </li>
            <li
              onClick={() => {
                toggleOverlay2(true);
              }}
            >
              Conditions générales
            </li>
          </ul>
        </div>
        <div className="w-25 contact-last">
          <h3>Notre adresse & Contact</h3>
          <ul>
            <li className="flex align-items-center justify-flex-start">
              <img
                className="contact-img mr-10"
                src={email}
                alt="email"
                height="37"
              />
              <div className="flex flex-column">
                <span className="grey small-text">Email</span>
                <span className="bold">
                  {pageContent && pageContent["contact-info"]
                    ? pageContent["contact-info"]["email"]
                    : null}
                </span>
              </div>
            </li>
            <li className="flex align-items-center justify-flex-start">
              <img
                className="contact-img mr-10"
                src={call}
                alt="email"
                height="37"
              />
              <div className="flex flex-column">
                <span className="grey small-text">Téléphone</span>
                <span className="bold">
                  {pageContent["contact-info"]
                    ? pageContent["contact-info"]["phone"]
                    : null}
                </span>
              </div>
            </li>
            <li className="flex align-items-center justify-flex-start">
              <img
                className="contact-img mr-10"
                src={location}
                alt="email"
                height="37"
              />
              <div className="flex flex-column">
                <span className="grey small-text">Adresse</span>
                <span className="bold">
                  <a
                    href={
                      pageContent["contact-info"]
                        ? pageContent["contact-info"]["map"]
                        : null
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Voir sur Google Maps
                  </a>
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-8 border-radius-5   flex footer-end">
        <div className="w-50 flex align-items-center footer-end-left justify-flex-start social-link">
          <div
            className="border-radius-20 bg-grey p-2 flex align-items-center mr-10 pointer "
            onClick={() =>
              openLinkInNewWindow(
                pageContent["contact-info"]
                  ? pageContent["contact-info"]["facebook"]
                  : null
              )
            }
          >
            <img
              src={facebook}
              alt="facebook-logo"
              className="mr-10"
              height="20"
            />
            <span className="small-text bold">Facebook</span>
          </div>
          <div
            className="border-radius-20 bg-grey p-2 flex align-items-center mr-10  pointer social-link"
            onClick={() =>
              openLinkInNewWindow(
                pageContent["contact-info"]
                  ? pageContent["contact-info"]["instagram"]
                  : null
              )
            }
          >
            <img
              src={instagram}
              alt="instagram-logo"
              className="mr-10"
              height="20"
            />
            <span className="small-text bold">Instagram</span>
          </div>
          <div
            className="border-radius-20 bg-grey p-2 flex align-items-center mr-10 pointer social-link"
            onClick={() =>
              openLinkInNewWindow(
                pageContent["contact-info"]
                  ? pageContent["contact-info"]["tiktok"]
                  : null
              )
            }
          >
            <img src={x} alt="tiktok-logo" className="mr-10" height="20" />
            <span className="small-text bold">TikTok</span>
          </div>
          <div
            className="border-radius-20 bg-grey p-2 flex align-items-center mr-10 pointer social-link"
            onClick={() =>
              openLinkInNewWindow(
                pageContent["contact-info"]
                  ? pageContent["contact-info"]["youtube"]
                  : null
              )
            }
          >
            <img
              src={youtube}
              alt="youtube-logo"
              className="mr-10"
              height="20"
            />
            <span className="small-text bold">YouTube</span>
          </div>
        </div>
        <div className="w-50 flex align-items-center footer-end-right justify-end social-link">
          <div className="border-radius-20 bg-grey  p-2 flex align-items-center mr-10 pointer ">
            <span className="small-text bold">© 2024 Tous droits réservés</span>
          </div>
          <div className="border-radius-20 bg-grey p-2 flex align-items-center mr-10 pointer ">
            <span
              className="small-text bold"
              onClick={() => {
                toggleOverlay2(true);
              }}
            >
              Conditions générales{" "}
            </span>
          </div>
          <div className="web border-radius-20 bg-grey p-2 flex align-items-center mr-10 pointer ">
            <span className="small-text bold">
              <img src={up_cheveron} alt="up-cheveron" height="15" />
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const Header = ({ setCartOpen, setAuthOpen, currentUser, onLogout }) => {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
  };

  const [isHovered, setIsHovered] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileMenuShown, setIsMobileMenuShown] = useState(false);
  const [isMobileCategoriesShwon, setIsMobileCategoriesShwon] = useState(false);
  const [selectedNavIndex, setSelectedNavIndex] = useState(0);
  const userMenuRef = useRef(null);
  const userMenuMobileRef = useRef(null);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);

  const { cart } = useContext(CartContext);
  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      console.log("fetching categories.....");
      try {
        console.log("fetching categories.....");
        const data = await getAllCategories();
        setCategories(data);
        console.log(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (!isUserMenuOpen) return;
    const handleOutsideClick = (e) => {
      const clickedDesktopMenu =
        userMenuRef.current && userMenuRef.current.contains(e.target);
      const clickedMobileMenu =
        userMenuMobileRef.current &&
        userMenuMobileRef.current.contains(e.target);
      if (!clickedDesktopMenu && !clickedMobileMenu) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isUserMenuOpen]);

  const getUserLabel = () => {
    if (!currentUser) return "Se Connecter";
    if (currentUser.name) return currentUser.name.split(" ")[0];
    if (currentUser.email) return currentUser.email.split("@")[0];
    return "Mon Compte";
  };

  return (
    <motion.div
      className="header max-z"
      initial={{ top: "-100px" }}
      animate={{
        top: 0,
        transition: { delay: 2.5, duration: 0.3, ease: "circInOut" },
      }}
      onClick={() => {
        if (window.screen.width < 500) {
          setTimeout(() => {
            setIsMobileMenuShown(!isMobileMenuShown);
          }, 150);
        }
      }}
    >
      <div className=" flex align-center ">
        <p
          className="logo-text home-logo pointer flex align-items-center"
          onClick={() => {
            window.location.href = "/";
          }}
        >
          <img alt="" src={logo} />
        </p>
      </div>

      <div className="navs flex web">
        {/* Home */}
        <motion.p
          className="nav-item mx-20 orange small-text pointer"
          onClick={() => {
            if (document.getElementById("home")) {
              scrollToSection("home");
              setSelectedNavIndex(0);
            } else {
              setTimeout(() => {
                setSelectedNavIndex(0);
                scrollToSection("home");
              }, 500); // Delay of 500ms
            }
          }}
          initial={{ color: "#00add8" }}
          animate={
            selectedNavIndex === 0 ? { color: "#00add8" } : { color: "#9babb8" }
          }
        >
          <Link to="/" className="link">
            Accueil
          </Link>
        </motion.p>

        {/* Section5 */}
        <motion.p
          className="nav-item mx-20 grey small-text pointer"
          onClick={() => {
            if (document.getElementById("section-tabs")) {
              scrollToSection("section-tabs");
              setSelectedNavIndex(5);
            } else {
              setTimeout(() => {
                scrollToSection("section-tabs");
                setSelectedNavIndex(5);
              }, 500); // Delay of 500ms
            }
          }}
          initial={{ color: "grey" }}
          animate={
            selectedNavIndex === 5 ? { color: "#00add8" } : { color: "#9babb8" }
          }
        >
          <Link to="/" className="link">
            Produits
          </Link>
        </motion.p>

        {/* Section2 */}
        <motion.p
          className="nav-item mx-20 grey small-text pointer"
          onClick={() => {
            if (document.getElementById("section2")) {
              scrollToSection("section2");
              setSelectedNavIndex(1);
            } else {
              setTimeout(() => {
                scrollToSection("section2");
                setSelectedNavIndex(1);
              }, 500); // Delay of 500ms
            }
          }}
          initial={{ color: "grey" }}
          animate={
            selectedNavIndex === 1 ? { color: "#00add8" } : { color: "#9babb8" }
          }
        >
          <Link to="/" className="link">
            Entreprise
          </Link>
        </motion.p>

        {/* Section3 */}
        <motion.p
          className="nav-item mx-20 grey small-text pointer"
          onClick={() => {
            if (document.getElementById("section3")) {
              scrollToSection("section3");
              setSelectedNavIndex(2);
            } else {
              setTimeout(() => {
                scrollToSection("section3");
                setSelectedNavIndex(2);
              }, 500); // Delay of 500ms
            }
          }}
          initial={{ color: "grey" }}
          animate={
            selectedNavIndex === 2 ? { color: "#00add8" } : { color: "#9babb8" }
          }
        >
          <Link to="/" className="link">
            À Propos
          </Link>
        </motion.p>

        {/* Section4 */}
        <motion.p
          className="nav-item mx-20 grey small-text pointer"
          onClick={() => {
            if (document.getElementById("section4")) {
              scrollToSection("section4");
              setSelectedNavIndex(6);
            } else {
              setTimeout(() => {
                scrollToSection("section4");
                setSelectedNavIndex(6);
              }, 500); // Delay of 500ms
            }
          }}
          initial={{ color: "grey" }}
          animate={
            selectedNavIndex === 6 ? { color: "#00add8" } : { color: "#9babb8" }
          }
        >
          <Link to="/" className="link">
            FAQ
          </Link>
        </motion.p>

        <motion.p
          className="nav-item mx-20 grey small-text pointer"
          onClick={() => {
            if (document.getElementById("after-sales-service")) {
              scrollToSection("after-sales-service");
              setSelectedNavIndex(7);
            } else {
              setTimeout(() => {
                scrollToSection("after-sales-service");
                setSelectedNavIndex(7);
              }, 500); // Delay of 500ms
            }
          }}
          initial={{ color: "grey" }}
          animate={
            selectedNavIndex === 7 ? { color: "#00add8" } : { color: "#9babb8" }
          }
        >
          <Link to="/" className="link">
            Service Après Vente
          </Link>
        </motion.p>

        {/* Categories Link */}
        <div
          className="flex relative mx-20 pointer"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => {
            setIsHovered(false);
          }}
        >
          <motion.p
            className="nav-item grey small-text"
            onClick={() => setSelectedNavIndex(8)}
            initial={{ color: "grey" }}
            animate={
              selectedNavIndex === 8 ? { color: "#00add8" } : { color: "grey" }
            }
          >
            <Link to="/products" className="link">
              Catégories
            </Link>
          </motion.p>
          <motion.img
            alt=""
            src={arrowDown}
            className="mx-5"
            initial={{ rotate: "0" }}
            animate={{ rotate: isHovered ? "180deg" : "0" }}
          />
          <HoverComponent
            width="60vw"
            height="fit-content"
            right="20px"
            isVisible={isHovered}
            className="hover-component"
            content={
              <div
                className="px-20 py-20 w-full h-full grid box-sizing "
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {categories.map((category) => (
                  <div
                    key={category.id}
                    className="category-item w-full flex align-items-center "
                  >
                    <img
                      alt={"category"}
                      src={category.imagesUrls[0]}
                      className=""
                    />

                    <Link to={"/products/" + category.id} className="link">
                      <p className="mx-20 grey small-text">
                        {category.categoryName}
                      </p>
                    </Link>
                  </div>
                ))}
              </div>
            }
          />
        </div>
      </div>


      <div className="flex">
        <div
          className="flex align-items-center mx-20 cart-icon-container relative"
          onClick={(e) => {
            e.stopPropagation();
            setCartOpen(true);
          }}
        >
          <div className="pointer">
            <img src={cartIcon} alt="cart" className="logo-img cart-img" />
          </div>
          {cartCount > 0 && (
            <div className="cart-count-badge">
              {cartCount}
            </div>
          )}
        </div>

        <div
          className="relative user-menu-wrapper web"
          ref={userMenuRef}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className={`action-button ${currentUser ? "bg-blue" : "bg-orange"}`}
            onClick={() => {
              if (currentUser) {
                setIsUserMenuOpen((prev) => !prev);
              } else {
                setAuthOpen(true);
              }
            }}
          >
            <p className="btn">{getUserLabel()}</p>
          </div>

          {currentUser && isUserMenuOpen && (
            <div className="user-menu">
              <p className="small-text grey">Connecté en tant que</p>
              <p className="bold">{currentUser.name || currentUser.email}</p>
              {currentUser.email && (
                <p className="small-text grey">{currentUser.email}</p>
              )}
              <div
                className="action-button bg-orange my-10"
                onClick={() => {
                  setIsUserMenuOpen(false);
                  setLogoutConfirmOpen(true);
                }}
              >
                <p className="btn">Se déconnecter</p>
              </div>
            </div>
          )}
        </div>

      </div>
      <div
        className="mobile-nav-toggle mobile"
        onClick={() => {
          if (window.screen.width < 500) {
            setTimeout(() => {
              setIsMobileMenuShown(!isMobileMenuShown);
            }, 150);
          }
        }}
      >
        <img src={mobileMenu} alt="menu-icon" className="logo-img"></img>

        <HoverComponent
          height="fit-content"
          width="100vw"
          right="0"
          className="mobile mobile-nav-menu my-0 max-z"
          isVisible={isMobileMenuShown}
          content={
            <div className="mobile-nav-menu-content black flex align-items-center">
              <div className="navs flex-column w-full mobile bg-white">
                <div
                  className="mobile mobile-connect-wrapper"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className="relative user-menu-wrapper"
                    ref={userMenuMobileRef}
                  >
                    <div
                      className={`action-button ${
                        currentUser ? "bg-blue" : "bg-orange"
                      }`}
                      onClick={() => {
                        if (currentUser) {
                          setIsUserMenuOpen((prev) => !prev);
                        } else {
                          setAuthOpen(true);
                        }
                      }}
                    >
                      <p className="btn">{getUserLabel()}</p>
                    </div>

                    {currentUser && isUserMenuOpen && (
                      <div className="user-menu">
                        <p className="small-text grey">Connecté en tant que</p>
                        <p className="bold">
                          {currentUser.name || currentUser.email}
                        </p>
                        {currentUser.email && (
                          <p className="small-text grey">
                            {currentUser.email}
                          </p>
                        )}
                        <div
                          className="action-button bg-orange my-10"
                          onClick={() => {
                            setIsUserMenuOpen(false);
                            setLogoutConfirmOpen(true);
                          }}
                        >
                          <p className="btn">Se déconnecter</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <motion.p
                  className="nav-item mx-20 orange small-text pointer"
                  onClick={() => {
                    if (document.getElementById("home")) {
                      scrollToSection("home");
                      setSelectedNavIndex(0);
                    } else {
                      setTimeout(() => {
                        setSelectedNavIndex(0);
                        scrollToSection("home");
                      }, 500); // Delay of 500ms
                    }
                  }}
                  initial={{ color: "#00add8" }}
                  animate={
                    selectedNavIndex === 0
                      ? { color: "#00add8" }
                      : { color: "#9babb8" }
                  }
                >
                  <Link to="/" className="link">
                    Accueil
                  </Link>
                </motion.p>

                {/* Section5 */}
                <motion.p
                  className="nav-item mx-20 grey small-text pointer"
                  onClick={() => {
                    if (document.getElementById("section-tabs")) {
                      scrollToSection("section-tabs");
                      setSelectedNavIndex(5);
                    } else {
                      setTimeout(() => {
                        scrollToSection("section-tabs");
                        setSelectedNavIndex(5);
                      }, 500); // Delay of 500ms
                    }
                  }}
                  initial={{ color: "grey" }}
                  animate={
                    selectedNavIndex === 5
                      ? { color: "#00add8" }
                      : { color: "#9babb8" }
                  }
                >
                  <Link to="/" className="link">
                    Produits
                  </Link>
                </motion.p>

                {/* Section2 */}
                <motion.p
                  className="nav-item mx-20 grey small-text pointer"
                  onClick={() => {
                    if (document.getElementById("section2")) {
                      scrollToSection("section2");
                      setSelectedNavIndex(1);
                    } else {
                      setTimeout(() => {
                        scrollToSection("section2");
                        setSelectedNavIndex(1);
                      }, 500); // Delay of 500ms
                    }
                  }}
                  initial={{ color: "grey" }}
                  animate={
                    selectedNavIndex === 1
                      ? { color: "#00add8" }
                      : { color: "#9babb8" }
                  }
                >
                  <Link to="/" className="link">
                    Entreprise
                  </Link>
                </motion.p>

                {/* Section3 */}
                <motion.p
                  className="nav-item mx-20 grey small-text pointer"
                  onClick={() => {
                    if (document.getElementById("section3")) {
                      scrollToSection("section3");
                      setSelectedNavIndex(2);
                    } else {
                      setTimeout(() => {
                        scrollToSection("section3");
                        setSelectedNavIndex(2);
                      }, 500); // Delay of 500ms
                    }
                  }}
                  initial={{ color: "grey" }}
                  animate={
                    selectedNavIndex === 2
                      ? { color: "#00add8" }
                      : { color: "#9babb8" }
                  }
                >
                  <Link to="/" className="link">
                    À Propos
                  </Link>
                </motion.p>

                {/* Section4 */}
                <motion.p
                  className="nav-item mx-20 grey small-text pointer"
                  onClick={() => {
                    if (document.getElementById("section4")) {
                      scrollToSection("section4");
                      setSelectedNavIndex(6);
                    } else {
                      setTimeout(() => {
                        scrollToSection("section4");
                        setSelectedNavIndex(6);
                      }, 500); // Delay of 500ms
                    }
                  }}
                  initial={{ color: "grey" }}
                  animate={
                    selectedNavIndex === 6
                      ? { color: "#00add8" }
                      : { color: "#9babb8" }
                  }
                >
                  <Link to="/" className="link">
                    FAQ
                  </Link>
                </motion.p>

                <motion.p
                  className="nav-item mx-20 grey small-text pointer"
                  onClick={() => {
                    if (document.getElementById("after-sales-service")) {
                      scrollToSection("after-sales-service");
                      setSelectedNavIndex(7);
                    } else {
                      setTimeout(() => {
                        scrollToSection("after-sales-service");
                        setSelectedNavIndex(7);
                      }, 500); // Delay of 500ms
                    }
                  }}
                  initial={{ color: "grey" }}
                  animate={
                    selectedNavIndex === 7
                      ? { color: "#00add8" }
                      : { color: "#9babb8" }
                  }
                >
                  <Link to="/" className="link">
                    Service Après Vente
                  </Link>
                </motion.p>
                <div className="flex justify-center align-items-center">
                  <Link
                    to="/"
                    className="link flex justify-center align-items-center"
                  >
                    <motion.p
                      className="nav-item grey small-text"
                      onClick={() => {
                        setTimeout(() => {
                          setIsMobileCategoriesShwon(true);
                        }, 200);
                      }}
                      initial={{ color: "grey" }}
                      animate={
                        selectedNavIndex === 8
                          ? { color: "#00add8" }
                          : { color: "grey" }
                      }
                    >
                      Catégories
                    </motion.p>
                    <motion.img
                      alt=""
                      src={arrowDown}
                      className="mx-5"
                      initial={{ rotate: "0" }}
                      animate={{ rotate: isHovered ? "180deg" : "0" }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          }
        />

        <HoverComponent
          height="fit-content"
          width="100vw"
          right="0"
          className="mobile mobile-nav-menu mobile-nav-menu2 my-0  bg-white"
          isVisible={isMobileCategoriesShwon}
          content={
            <div
              className=" w-full h-full grid box-sizing"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <div
                className="outside-click absolute w-full h-full top0 left0 "
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMobileCategoriesShwon(false);
                }}
              ></div>
              {categories.map((category) => (
                <div
                  key={category.id}
                  className="category-item w-full flex align-items-center "
                  onClick={() => {
                    setIsMobileCategoriesShwon(false);
                    setTimeout(() => {
                      setIsMobileMenuShown(false);
                    }, 200);
                  }}
                >
                  <img
                    alt={category.name}
                    src={category.imagesUrls[0]}
                    className=""
                  />
                  <Link to={"/products/" + category.id} className="link">
                    <p className="mx-20 grey small-text">
                      {category.categoryName}
                    </p>
                  </Link>
                </div>
              ))}
            </div>
          }
        />
      </div>
      <AlertOverlay
        stat={logoutConfirmOpen}
        title="Confirmation"
        message="Voulez-vous vous déconnecter ?"
        confirmText="Oui"
        cancelText="Non"
        onConfirm={async () => {
          if (onLogout) await onLogout();
          setLogoutConfirmOpen(false);
        }}
        onClose={() => setLogoutConfirmOpen(false)}
      />
    </motion.div>
  );
};
export default App;



